import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import { Grid } from '@mui/material';
import { motion } from 'framer-motion';

const skills = [
  { name: 'Java', level: 90 },
  { name: 'SpringBoot', level: 85 },
  { name: 'Oracle', level: 80 },
  { name: 'JavaScript', level: 75 },
  { name: 'Kafka', level: 70 },
  { name: 'Gemfire', level: 65 },
  { name: 'Cassandra', level: 60 },
  { name: 'MySQL', level: 55 },
  { name: 'C#, .NET, .netcore, asp.net', level: 50 },
  { name: 'React', level: 45 },
  { name: 'TypeScript', level: 40 },
  { name: 'Node.js', level: 35 },
  { name: 'Python', level: 30 },
  { name: 'SQL', level: 25 },
  { name: 'AWS', level: 20 },
];

const About: React.FC = () => {
  return (
    <Box sx={{ py: 8, minHeight: '100vh' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" component="h1" gutterBottom>
            About Me
          </Typography>
          <Typography variant="h5" color="text.secondary" paragraph>
            I'm a passionate Full Stack Developer with a strong foundation in web
            technologies, backend services, relational and NoSQL databases, Messaging platforms, and a keen eye for creating elegant solutions.
          </Typography>

          <Box sx={{ my: 6 }}>
            <Typography variant="h4" gutterBottom>
              Skills
            </Typography>
            <Grid container spacing={3}>
              {skills.map((skill) => (
                <Grid key={skill.name} xs={12} sm={6} md={4}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      height: '100%',
                      background: 'rgba(255, 255, 255, 0.05)',
                    }}
                  >
                    <Typography variant="h6" gutterBottom>
                      {skill.name}
                    </Typography>
                    <Box
                      sx={{
                        width: '100%',
                        height: 8,
                        bgcolor: 'background.paper',
                        borderRadius: 1,
                        overflow: 'hidden',
                      }}
                    >
                      <Box
                        sx={{
                          width: `${skill.level}%`,
                          height: '100%',
                          bgcolor: 'primary.main',
                          transition: 'width 1s ease-in-out',
                        }}
                      />
                    </Box>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Box sx={{ my: 6 }}>
            <Typography variant="h4" gutterBottom>
              Experience
            </Typography>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                background: 'rgba(255, 255, 255, 0.05)',
              }}
            >
              <Typography variant="h6" gutterBottom>
                Vice President |Lead Software Engineer - J.P Morgan Chase Bank
              </Typography>
              <Typography color="text.secondary" paragraph>
                Singapore
              </Typography>
              <Typography color="text.secondary" paragraph>
                2014 - Present
              </Typography>
              <Typography paragraph>
                • Led development of multiple full-stack applications using Java, Springboot, Kafka, Oracle, Gemfire, Cassandra, MySQL, C#, .NET, .netcore, asp.net
                <br />
                • Implemented CI/CD pipelines and automated testing
                <br />
                • Mentored junior developers and conducted code reviews
              </Typography>
            </Paper>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                background: 'rgba(255, 255, 255, 0.05)',
              }}
            >
              <Typography variant="h6" gutterBottom>
                Lead Consultant | Senior Software Engineer - Genpact Headstrong Capital Markets
              </Typography>
              <Typography color="text.secondary" paragraph>
                Singapore
              </Typography>
              <Typography color="text.secondary" paragraph>
                June, 2014 - October, 2014
              </Typography>
              <Typography paragraph>
                • Led development of multiple full-stack applications using Java, Springboot, Kafka, Oracle, Gemfire, Cassandra, MySQL, C#, .NET, .netcore, asp.net
                <br />
                • Implemented CI/CD pipelines and automated testing
                <br />
                • Mentored junior developers and conducted code reviews
              </Typography>
            </Paper>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default About; 